import { genericService } from "./genericService";
import { akeronService } from "./akeronService";


const section = "PackingList";
function findLatest(idTrip, numContainer) {
  return genericService.get(`${section}/FindLatest/${idTrip}/${numContainer}`);
}

function update(data) {
  return akeronService.make_put_request(`${section}/UpdateProductFamily`, data);
}

export const packingListService = {
  findLatest,
  update,
};
